import { BadgeSize } from 'omakase/Badge/Badge';
import { Theme, css } from '@emotion/react';
import { assertNever } from '@tock/shared/utils/typeUtils';

const getBadgeSizeFromSize = (size: BadgeSize) => {
  switch (size) {
    case 'small':
      return 10;
    case 'medium':
      return 12;
    case 'large':
      return 14;
    case 'xLarge':
      return 16;
    default:
      assertNever(size);
  }
};

export const badge = (
  { timings, colors, zIndex, borderRadius }: Theme,
  size: BadgeSize,
  { invisible, hasContent }: { invisible: boolean; hasContent: boolean }
) => {
  const badgeDiameter = getBadgeSizeFromSize(size);

  return [
    css`
      transition: all ${timings.duration.shortest} ${timings.timingFunction.easeInOut};

      & .MuiBadge-badge {
        background-color: ${colors.bgPrimaryBase};

        z-index: calc(${2 * zIndex.bump});
      }

      & .MuiBadge-dot {
        border-radius: ${borderRadius.Pill};
        display: inline-block;
        height: ${badgeDiameter}px;
        width: ${badgeDiameter}px;
        transform: scale(${invisible ? 0 : 1});
      }
    `,
    hasContent &&
      css`
        & .MuiBadge-badge {
          top: 4px;
          right: 4px;
        }
      `,
  ];
};
